import React, { Component} from 'react';

import Select from './../Select';

const data = [
    {value: 1, label: "12-13学年"},
    {value: 2, label: "13-14学年"},
    {value: 3, label: "14-15学年"},
    {value: 4, label: "15-16学年"},
    {value: 5, label: "16-17学年"},
    {value: 6, label: "17-18学年"},
    {value: 7, label: "18-19学年"},
    {value: 8, label: "19-20学年"},
];

const TermIdYear = (props) => (
    <Select name="termIdYear" label="所属学年" data={data} {...props} ></Select>
);

export default TermIdYear;